
export enum ViewpointValidationTranslationKey {
    DIAGRAM_INVALID = "diagrams.editor.validation.viewpoint.diagramInvalid",
    DIAGRAM_VALID = "diagrams.editor.validation.viewpoint.diagramValid",
    INCORRECT_ELEMENTS_COUNT = "diagrams.editor.validation.viewpoint.incorrectElementsCount",
    REPORT_TITLE = "diagrams.editor.validation.viewpoint.reportTitle",
    UNEXPECTED_ERROR = "diagrams.editor.validation.viewpoint.unexpectedError",
    VALIDATE_IN_PROGRESS = "diagrams.editor.validation.viewpoint.validationInProgress",
    VIEWPOINT_NOT_DEFINED_ERROR = "diagrams.editor.validation.viewpoint.viewpointNotDefinedError",
}